import React, { useCallback } from 'react';
import { LabelWithTextBox, LabelWithTextBoxProps } from 'components/input';
import { PuckDewarContainerView } from '../puck/constants';
import { useAllDewars, useAllPucks, useSelectedCrystalId } from 'redux/hooks/synchrotron';
import { CrystalDataDTO } from '../constants';
import { getCrystalById, getDewarById, getCrystalsByDewarId } from './utils';

interface Props {
  setContentView: (view: PuckDewarContainerView) => void;
  disabled: boolean;
  crystals: CrystalDataDTO[];
}
const DewarInfo = (props: Props) => {
  const { setContentView, crystals, disabled } = props;
  const selectedCrystalId = useSelectedCrystalId();
  const pucks = useAllPucks();
  const dewars = useAllDewars();
  const selectedCrystal = getCrystalById(crystals, selectedCrystalId);

  const selectedDewar = getDewarById(
    dewars,
    selectedCrystal?.crystalContainerAssignments?.dewarId,
  );

  const crystalsOfSelectedDewar = getCrystalsByDewarId(crystals, selectedDewar?.id);
  const pucksOfSelectedDewar = [
    ...new Set(
      crystalsOfSelectedDewar.map((item) => item.crystalContainerAssignments.puckId),
    ),
  ];
  const totalPinCount = pucks
    .filter((puck) => pucksOfSelectedDewar.includes(puck.id))
    .reduce((acc, puck) => acc + puck.puckType.pinCount, 0);

  const dewarInfos: LabelWithTextBoxProps[] = [
    {
      label: 'Puck Count',
      value: selectedDewar ? selectedDewar.puckCount.toString() : '',
      labelWidth: '60%',
      textBoxWidth: '40%',
      disabled,
    },
    {
      label: 'Total Pin',
      value: totalPinCount ? totalPinCount?.toString() : '',
      labelWidth: '60%',
      textBoxWidth: '40%',
      labelClass: 'justify-center',
      disabled,
    },
    {
      label: 'Available',
      value:
        selectedDewar && totalPinCount
          ? (totalPinCount - crystalsOfSelectedDewar.length).toString()
          : '',
      labelWidth: '60%',
      textBoxWidth: '40%',
      labelClass: 'justify-center',
      disabled,
    },
  ];

  const renderDewarInfoLabelWithValue = () =>
    dewarInfos.map((item, index) => <LabelWithTextBox key={index} {...item} />);

  const handleOnDewarClick = useCallback(() => {
    setContentView(PuckDewarContainerView.SelectDewarView);
  }, [setContentView]);

  return (
    <div id="puckdewarcontainer-dewarinfo-wrapper" className="flex flex-col w-full">
      <div
        id="puckdewarcontainer-dewarinfo-title"
        className="text-base font-semibold text-gray-700 w-[80%]"
      >
        Dewar
      </div>
      <LabelWithTextBox
        label="Dewar"
        value={selectedDewar?.name ?? 'Select Dewar'}
        labelWidth={'20%'}
        textBoxWidth={'80%'}
        onClick={handleOnDewarClick}
        disabled={disabled}
      />
      <div
        id="puckdewarcontainer-dewarinfo-label-with-value"
        className="flex flex-row w-full"
      >
        {renderDewarInfoLabelWithValue()}
      </div>
    </div>
  );
};

export default DewarInfo;
